import React, { useEffect, useState } from "react";

const photos = [
  { img: "/img/Sector62.jpg", name: "Sector 62, Noida" },
  { img: "/img/Greater-Noida.jpg", name: "SARC building, Greater Noida" },
  { img: "/img/Ghaziabad.jpg", name: "Rajendra Nagar, Ghaziabad" },
  { img: "/img/Bennett-University.webp", name: "Bennett University, Greater Noida" },
  { img: "/img/BML-Munjal-University1.webp", name: "BML Munjal University, Haryana" },
];

const Location_pic = () => {
  const [current, setCurrent] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % photos.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [isPaused]);

  return (
    <figure
      className="overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-[#1f5c33]/10"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="relative aspect-[16/10] bg-[#eef5ef]">
        {photos.map((photo, index) => (
          <img
            key={photo.img}
            src={photo.img}
            alt={index === current ? `GreeNox outlet at ${photo.name}` : ""}
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover transition-opacity duration-700"
            style={{ opacity: index === current ? 1 : 0 }}
          />
        ))}
      </div>
      <figcaption className="flex items-center justify-between gap-3 px-5 py-4">
        <span className="text-sm font-semibold text-[#1f5c33]">
          {photos[current].name}
        </span>
        <span className="flex shrink-0 gap-1.5">
          {photos.map((photo, index) => (
            <button
              key={photo.img}
              type="button"
              onClick={() => setCurrent(index)}
              aria-label={`Show ${photo.name}`}
              aria-current={index === current}
              className={`h-2 rounded-full transition-all ${
                index === current ? "w-5 bg-[#1f5c33]" : "w-2 bg-[#1f5c33]/25 hover:bg-[#1f5c33]/50"
              }`}
            />
          ))}
        </span>
      </figcaption>
    </figure>
  );
};

export default Location_pic;
